import type { PropsWithChildren } from 'react';

import Divider from '@/app/components/ui/Divider';

import { DialogDescription, DialogHeader, DialogTitle } from '..';

type HeaderProps = PropsWithChildren<{
  readonly title?: string;
  readonly description?: React.ReactNode;
  readonly TitleIcon?: React.ReactNode;
}>;

const DialogHeaderGroup = ({
  title,
  description,
  TitleIcon,
  children,
}: HeaderProps) => {
  return (
    <DialogHeader>
      {title && <DialogTitle Icon={TitleIcon}>{title}</DialogTitle>}
      {description && <DialogDescription>{description}</DialogDescription>}
      {children}
      <Divider color="gray-15" className="mt-5" />
    </DialogHeader>
  );
};

export { DialogHeaderGroup };
